<template>
    <div class="top-bar">
        <DsInline fill spread align-y="center">
            <router-link class="home" to="/">
                <div class="title">
                    {{ $t("partnerTeams") }}
                </div>
            </router-link>

            <DsTextButton as="a" href="logout">
                {{ $t("logout") }}
            </DsTextButton>
        </DsInline>
    </div>
</template>

<style lang="scss" scoped>
.top-bar {
    position: sticky;
    top: 0;
    z-index: 1;
    width: 100%;
    border-bottom: 1px solid $color-ink-200;
    padding: $spacing-100;
}

.home {
    color: $color-ink;
    text-decoration: none;
    padding: $spacing-100;

    .title {
        font-size: $font-size-md;

        @media(max-width: px-to-rem(250)) {
            display: none;
        }
    }
}
</style>

<i18n>
{
    "en-us": {
        "partnerTeams": "Partner Teams",
        "logout": "Logout"
    }
}
</i18n>
